import { BaseDTO } from './basedto';

export class PackageLevelTemplate extends BaseDTO {
    TeslaEquipmentCode: string;
    PackageTypeId: number;
    PackageTypeDescription: string;
    PackageMaterialId: number;
    IsShippable: boolean;
    PackageMaterialDescription: string;
    TransportModeId: number;
    TransportModeDescription: string;
    IsTeslaCreated: boolean;
    ODLength: number;
    ODWidth: number;
    ODHeight: number;
    IDLength: number;
    IDWidth: number;
    IDHeight: number;
    CollapsedHeight: number;
    ContainersPerLayer: number;
    TareWeight: number;
    BoxDesign: string;
    ColorCode: string;
    MaxWeight: string;
    BurstStrength: string;
    ECT: number;
    FluteSize: string;
    ReturnRatio: string;
    UOMSystemId: number;
    SupplierCode: string;
    EnoviaCode: string;
    EffectiveFrom: Date;
    EffectiveTo: Date;
    EffectiveFromConstraint: Date;
    EffectiveToConstraint: Date;
    HasProposalsThatHaveAlreadyStarted: boolean;
    IsBeingReferenced: boolean;
}
